import { render, staticRenderFns } from "./DsfaForm.vue?vue&type=template&id=53173e13&"
import script from "./DsfaForm.vue?vue&type=script&lang=js&"
export * from "./DsfaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DsfaForm.vue"
export default component.exports